import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { array, bool, object, oneOfType, string } from 'prop-types';
import { AddOnBlock, Box, Text } from '@landtrustinc/design-system';
import { getLodgingIcon } from '../../util/lodging';
import { handleLodgingAddOnChange } from '../../util/package';
import css from './InquiryLodgingAddOns.module.css';

const InquiryLodgingAddOns = ({
  optionalLodging,
  lodgingAddons,
  dateValues,
  availableDays,
  hasLodging,
  form,
}) => (
  <div className={css.packageLodgingAddOn}>
    <Box mb="var(--spacing-3)">
      <Text as="p" size="sm" fontWeight="semibold" color="var(--text-primary)">
        <FormattedMessage id="InquiryWizard.addOnsTitle" />
      </Text>
    </Box>
    <Box display="flex" flexDirection="column" gap="var(--spacing-2)">
      {optionalLodging.map((item, index) => {
        const uniqueKey = `${item.type}-${item.index || index}`;
        return (
          <Field key={uniqueKey} name="lodgingAddons" type="checkbox" value={index}>
            {({ input }) => (
              <AddOnBlock
                title={item.shortLabel}
                subtitle={`+ ${item.priceLabel}`}
                icon={getLodgingIcon(item.type)}
                checked={input.checked}
                onClick={() => {
                  const updatedAddons = handleLodgingAddOnChange(
                    index,
                    lodgingAddons || [],
                    dateValues,
                    availableDays,
                    hasLodging,
                    form.change
                  );
                  form.change('lodgingAddons', updatedAddons);
                }}
              />
            )}
          </Field>
        );
      })}
    </Box>
  </div>
);

InquiryLodgingAddOns.defaultProps = {
  lodgingAddons: null,
  dateValues: null,
  availableDays: null,
  hasLodging: null,
};

InquiryLodgingAddOns.propTypes = {
  optionalLodging: array.isRequired,
  lodgingAddons: array,
  dateValues: object,
  availableDays: array,
  hasLodging: oneOfType([bool, string]),
  form: object.isRequired,
};

export default InquiryLodgingAddOns;
